<template>
  <div style="position: relative">
    <ColumnVisibilitySidebar
      :id="columnSidebarId"
      module-label="OS"
      :fields="fields"
      :visible-fields="fieldsToShow"
      @save="handleSaveFields"
    />

    <FilterFields
      :fields="[
        {
          type: 'text',
          label: 'Número',
          field: 'numero',
        },
        {
          type: 'text',
          label: 'Cliente',
          field: 'cliente',
        },
        {
          type: 'text',
          label: 'Técnico',
          field: 'tecnico',
        },
        {
          type: 'text',
          label: 'Objeto',
          field: 'objeto',
        },
        {
          type: 'text',
          label: 'Local de Atendimento',
          field: 'local_atendimento',
        },
        {
          type: 'date',
          label: 'Dt. Entrada',
          field: 'dataEntrada',
        },
        {
          type: 'date',
          label: 'Dt. Saída',
          field: 'dataSaida',
        },
        {
          type: 'date',
          label: 'Dt. Conclusão',
          field: 'dataConclusao',
        },
        {
          type: 'text',
          label: 'Identificador',
          field: 'identificador',
        },
        {
          type: 'text',
          label: 'Solicitante',
          field: 'solicitante',
        },
        {
          type: 'select',
          label: 'Status',
          field: 'status',
          options: [
            'Todos',
            'Em aberto',
            'Orçada',
            'Autorizada',
            'Cancelada',
            'Exportada (NFe/NFSe)',
            'Não autorizada',
            'Análise do cliente',
            'Em andamento',
            'Finalizada',
            'Aguardando Componentes',
            'Serviço Concluído',
            'Finalizada sem concerto',
            'Aprovado',
            'Sem defeito',
            'Faturada',
            'Entregue aguardando faturamento',
          ],
        },
      ]"
    />

    <b-dropdown
      id="menu"
      variant="dark"
      v-b-tooltip.right="'Mais ações'"
      class="mb-5"
      style="position: absolute; top: 0; left: 50px"
      v-if="actionsStore.selectedRows.length > 0"
    >
      <template #button-content>
        <Menu :size="18" />
      </template>
      <b-dropdown-item
        v-b-modal.duplicarOS
        :disabled="actionsStore.selectedRows.length > 1"
      >
        Duplicar OS
      </b-dropdown-item>
      <b-dropdown-item v-b-modal.atualizarOS>
        Atualizar status
      </b-dropdown-item>
      <b-dropdown-item
        v-b-modal.comprovanteEntrega
        :disabled="actionsStore.selectedRows.length > 1"
      >
        Comprovante de entrega
      </b-dropdown-item>
      <b-dropdown-item
        v-b-modal.modalEtiqueta
        :disabled="actionsStore.selectedRows.length > 1"
      >
        Etiqueta
      </b-dropdown-item>
      <b-dropdown-item
        v-if="!store.pafNFCe && actionsStore.selectedRows[0]?.status != 5"
        v-b-modal.faturarOS
        :disabled="
          actionsStore.selectedRows.length > 1 ||
          actionsStore.selectedRows[0]?.status == 14
        "
      >
        Faturar OS
      </b-dropdown-item>
      <b-dropdown-item
        v-b-modal.copiaArquivo
        :disabled="actionsStore.selectedRows.length > 1"
      >
        Anexar cópia
      </b-dropdown-item>
      <b-dropdown-item
        v-b-modal.dataBaixa
        :disabled="actionsStore.selectedRows.length > 1"
      >
        Data de saída
      </b-dropdown-item>
      <b-dropdown-item
        v-if="actionsStore.selectedRows[0]?.status == 14"
        v-b-modal.estornarOSModal
        :disabled="actionsStore.selectedRows.length <= 0"
      >
        Estornar OS
      </b-dropdown-item>
    </b-dropdown>

    <b-button
      class="border border-muted"
      variant="secondary"
      v-b-tooltip.hover.right="'Customizar colunas'"
      style="position: absolute; right: 0; top: 0"
      @click="$root.$emit('bv::toggle::collapse', columnSidebarId)"
    >
      <ToggleSwitchOutline :size="20" />
    </b-button>

    <b-modal
      id="dataBaixa"
      title="Deseja atualizar a data de saída na OS?"
      centered
      size="xs"
    >
      <label
        ><p>
          Informe a data de saída da OS:
          {{ actionsStore.selectedRows[0]?.numero }}
        </p>
      </label>
      <b-row>
        <b-col sm="12">
          <b-form-group
            id="dataConclusao"
            label-for="dataConclusao"
            label="Data de conclusão"
          >
            <b-form-datepicker
              v-model="dataSaida"
              locale="pt-br"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="updateDataSaida"
            ref="dataSaidaButton"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="copiaArquivo" title="Deseja anexar cópia?" centered size="xs">
      <label
        ><p>
          Inserir cópia da OS número: {{ actionsStore.selectedRows[0]?.numero }}
        </p>
      </label>
      <b-row>
        <b-col md="6">
          <input
            id="fileUpload"
            type="file"
            accept=".jpg, .png, .pdf"
            @change="setAnexoCopia"
          />
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="anexarCopia"
            ref="copiaAnexo"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="comprovanteEntrega"
      title="Deseja imprimir o comprovante de entrega do Objeto?"
      centered
      size="xs"
    >
      <label
        ><p>
          OS a ser impressa número: {{ actionsStore.selectedRows[0]?.numero }}
        </p>
      </label>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="imprimirComprovante"
            ref="comprovanteEntrega"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="faturarOS" title="Deseja faturar a OS?" centered size="xs">
      <label>
        <p>
          <strong
            >OS a ser faturada número:
            {{ actionsStore.selectedRows[0]?.numero }}
          </strong>
        </p>
        <p v-if="actionsStore.selectedRows[0]?.pagamentos">
          Forma Pagamento:
          {{ formataPagamento(actionsStore.selectedRows[0]?.pagamentos) }}
        </p>
      </label>
      <b-row>
        <b-col md="6">
          <p class="font-weight-bolder text-dark mb-2">Movimentar estoque</p>
          <span class="switch switch-icon">
            <label v-b-tooltip.hover.right="'Não/Sim'">
              <input type="checkbox" v-model="movimentar_estoque" />
              <span></span>
            </label>
          </span>
        </b-col>
        <b-col md="6">
          <p class="font-weight-bolder text-dark mb-2">Gerar financeiro</p>
          <span class="switch switch-icon">
            <label v-b-tooltip.hover.right="'Não/Sim'">
              <input type="checkbox" v-model="gerar_financeiro" />
              <span></span>
            </label>
          </span>
        </b-col>
        <b-col md="12" style="margin-top: 10px">
          <b-form-group
            id="data_faturamento"
            label-for="data_faturamento"
            label="Data do Faturamento"
          >
            <b-form-input v-model="data_faturamento" type="date" required />
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="faturarOrdemServico"
            ref="faturarOrdemServico"
            class="mr-5"
            :disabled="permitido_faturar"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="modalEtiqueta"
      title="Deseja imprimir a etiqueta referente a OS?"
      centered
      size="xs"
      @show="etiquetaCompleta = false"
    >
      <label
        ><p>
          OS a ser impressa número: {{ actionsStore.selectedRows[0]?.numero }}
        </p>
      </label>
      <b-col md="12">
        <b-form-group label="Informe a quantidade de etiquetas">
          <b-form-input
            type="number"
            min="1"
            max="10"
            v-model="repetirEtiqueta"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-checkbox v-model="etiquetaCompleta" switch>
          Etiqueta completa
        </b-form-checkbox>
      </b-col>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="imprimirEtiqueta"
            ref="imprimirEtiqueta"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="duplicarOS"
      title="Deseja duplicar a OS selecionada?"
      centered
      size="xs"
    >
      <label
        >OS a ser duplicada
        <p>Número: {{ actionsStore.selectedRows[0]?.numero }}</p>
      </label>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="duplicar"
            ref="doubleOS"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="atualizarOS"
      title="Deseja atualizar o status da(s) OS selecionada(s)?"
      centered
      size="xs"
    >
      <label
        >OS(s) para mudar o status
        <p>
          Número(s):
          {{ actionsStore.selectedRows.map((os) => os.numero).join(",") }}
        </p>
      </label>
      <b-form-group label="Selecione o status" label-for="status">
        <VueSelect
          ref="buscarStatus"
          :filterable="false"
          :options="osStatus"
          v-model="statusSelected"
        >
          <template slot="no-options"> Informe o status </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.descricao }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.descricao }}
            </div>
          </template>
        </VueSelect>
      </b-form-group>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="atualizarStatus"
            ref="updateOS"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="estornarOSModal" title="Estornar OS?" size="md" centered>
      <div class="mx-auto">
        <b-form class="form">
          <b-row>
            <b-col>
              Deseja estornar a OS número:
              {{ actionsStore?.selectedRows[0]?.numero }}
            </b-col>
          </b-row>
        </b-form>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button variant="primary" ref="estornar_os" @click="estornarOS">
          Salvar
        </b-button>
      </template>
    </b-modal>

    <div class="os-status-summary">
      <table class="os-status-summary-table">
        <thead>
          <tr>
            <th>Total de OS</th>
            <th>OS não faturadas</th>
            <th>OS faturadas</th>
            <th>
              <b-form-select
                v-model="statusResumoSelecionado"
                class="os-status-summary-select"
              >
                <b-form-select-option :value="null" disabled>
                  Escolha um status
                </b-form-select-option>
                <b-form-select-option
                  v-for="status in osStatus"
                  :key="status.id"
                  :value="status"
                >
                  {{ status.descricao }}
                </b-form-select-option>
              </b-form-select>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span class="os-status-summary-value">
                {{ totalOrdensServico }}
              </span>
            </td>
            <td>
              <span class="os-status-summary-value">
                {{ totalOrdensServicoNaoFaturadas }}
              </span>
            </td>
            <td>
              <span class="os-status-summary-value">
                {{ totalOrdensServicoFaturadas }}
              </span>
            </td>
            <td>
              <span
                v-if="statusResumoSelecionado"
                class="os-status-summary-value"
              >
                {{ totalOrdensServicoPorStatus }}
              </span>
              <span v-else class="text-muted font-size-sm">
                Escolha um status
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <TableApp
      titulo="Ordem de Serviço"
      acaoBtn="/#/ordensServicos-nova"
      textoBtn="Nova OS"
      api-url="/ordemservico/lista"
      :fields="fieldsToShow"
      classFilterColumn="numero"
      ref="osList"
      :perPage="10"
      :multiselect="true"
    >
      <template slot="customRow" scope="props">
        <span slot="numero" class="pl-0 pt-8" v-if="props.field == 'numero'">
          <div class="d-flex align-items-center">
            <div
              class="font-weight-bold"
              v-if="
                !props.rowData.copia_arquivo && !props.rowData.numero_interno
              "
            >
              {{ props.rowData.numero }}
            </div>
            <div
              class="font-weight-bold"
              v-if="
                props.rowData.copia_arquivo && !props.rowData.numero_interno
              "
              v-b-tooltip.bottom="'Ver cópia da OS'"
            >
              <a :href="props.rowData.copia_arquivo" target="_blank">{{
                props.rowData.numero
              }}</a>
            </div>
            <div
              class="font-weight-bold"
              v-if="props.rowData.copia_arquivo && props.rowData.numero_interno"
              v-b-tooltip.bottom="'Ver cópia da OS'"
            >
              <a :href="props.rowData.copia_arquivo" target="_blank">{{
                props.rowData.numero_interno
              }}</a>
            </div>
            <div
              class="font-weight-bold"
              v-if="
                !props.rowData.copia_arquivo && props.rowData.numero_interno
              "
              v-b-tooltip.bottom="'Ver cópia da OS'"
            >
              <a :href="props.rowData.copia_arquivo" target="_blank">{{
                props.rowData.numero_interno
              }}</a>
            </div>
            <b-button
              v-if="temAnexo(props.rowData)"
              @click.stop="abrirModalAnexos(props.rowData)"
              variant="link"
              size="sm"
              class="p-0 ml-2"
              v-b-tooltip.hover="'Ver anexos'"
              style="vertical-align: middle"
            >
              <PaperclipIcon :size="18" />
            </b-button>
          </div>
        </span>
        <span slot="cliente" class="pl-0 pt-8" v-if="props.field == 'cliente'">
          <div class="d-flex align-items-center">
            <div class="font-weight-bold">
              {{ props.rowData.cliente }}
              <br v-if="clienteTelefone(props.rowData)" />
              <small v-if="clienteTelefone(props.rowData)">
                {{ clienteTelefone(props.rowData) }}
              </small>
            </div>
          </div>
        </span>
        <span slot="objeto" class="pl-0 pt-8" v-if="props.field == 'objeto'">
          <div class="d-flex align-items-center">
            <div class="font-weight-bold">
              {{ props.rowData.objeto.descricao }}
            </div>
          </div>
        </span>
        <span
          slot="local_atendimento"
          class="pl-0 pt-8"
          v-if="props.field == 'local_atendimento'"
        >
          <span
            class="font-weight-bold os-local-atendimento"
            v-b-tooltip.hover.top="localAtendimentoLabel(props.rowData)"
          >
            {{ localAtendimentoLabel(props.rowData) }}
          </span>
        </span>
        <span
          slot="identificadores"
          class="pl-0 pt-8"
          v-if="props.field == 'identificadores'"
        >
          <div class="d-flex align-items-center">
            <div class="font-weight-bold">
              {{ formataIdentificadores(props.rowData.identificadores) }}
            </div>
          </div>
        </span>
        <span slot="tecnico" class="pl-0 pt-8" v-if="props.field == 'tecnico'">
          <div class="d-flex align-items-center">
            <div class="font-weight-bold" v-if="props.rowData.tecnico">
              {{ props.rowData.tecnico.nome }}
            </div>
            <div class="font-weight-bold" v-else></div>
          </div>
        </span>
        <span
          slot="dataEntrada"
          class="pl-0 pt-8"
          v-if="props.field == 'dataEntrada'"
        >
          <div class="d-flex align-items-center">
            <div class="font-weight-bold">
              {{ props.rowData.dataEntrada | moment("DD/MM/YYYY") }}
            </div>
          </div>
        </span>
        <span
          slot="dataPrevisao"
          class="pl-0 pt-8"
          v-if="props.field == 'dataPrevisao'"
        >
          <div class="d-flex align-items-center">
            <div class="font-weight-bold">
              {{ props.rowData.dataPrevisao | moment("DD/MM/YYYY") }}
            </div>
          </div>
        </span>
        <span
          slot="dataSaida"
          class="pl-0 pt-8"
          v-if="props.field == 'dataSaida'"
        >
          <div class="d-flex align-items-center">
            <div class="font-weight-bold">
              {{ props.rowData.dataSaida | moment("DD/MM/YYYY") }}
            </div>
          </div>
        </span>
        <span
          slot="status"
          v-if="props.field == 'status'"
          :class="statusOSClass(props.rowData.status)"
        >
          {{ statusOSLabel(props.rowData.status) }}
        </span>
        <span
          slot="valorTotal"
          v-if="props.field == 'valorTotal'"
          class="text-dark-75 font-weight-bolder d-block font-size-lg"
        >
          R$
          {{ numberToReal(props.rowData.valorTotal, 2) }}
        </span>
        <span
          slot="actions"
          v-if="props.field == 'actions'"
          class="text-dark-75 font-weight-bolder d-block font-size-lg"
        >
          <div class="action-buttons">
            <button
              @click="imprimirOS(props.rowData)"
              v-b-tooltip.bottom="'Impressão da OS'"
              class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
            >
              <PdfIcon :size="22" />
            </button>
            <button
              @click="imprimirOSTecnico(props.rowData)"
              v-b-tooltip.bottom="'Imprimir OS para técnico'"
              class="btn btn-sm btn-warning btn-icon mr-2"
            >
              <PdfIcon :size="22" />
            </button>
            <button
              @click="editarOS(props.rowData)"
              class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
              v-b-tooltip.bottom="'Editar OS'"
              v-if="
                props.rowData.status !== 3 &&
                props.rowData.status !== 11 &&
                props.rowData.status !== 12 &&
                props.rowData.status !== 14 &&
                props.rowData.status !== 5
              "
            >
              <PencilIcon :size="20" />
            </button>
            <button
              @click="doCopy(props.rowData, props.rowData.id_ordem_servico)"
              class="btn btn-sm btn-success btn-hover-success btn-icon mr-2"
              v-b-tooltip.hover.bottom="'Copiar Link'"
              placement="bottom"
            >
              <Link :size="16" />
            </button>
            <button
              @click="deleteOS(props.rowData)"
              v-if="props.rowData.status === 1"
              v-b-tooltip="'Deletar OS'"
              class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
            >
              <Close :size="20" />
            </button>
            <button
              @click="shareToWhatsapp(props.rowData)"
              v-b-tooltip.hover.bottom="'Encaminhar para o WhatsApp'"
              class="btn btn-sm btn-success btn-hover-success btn-icon mr-2"
            >
              <Whatsapp :size="20" />
            </button>
            <button
              @click="linkOSFaturada(props.rowData)"
              class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
              v-b-tooltip.bottom="'OS Faturada'"
              v-if="props.rowData.status == 14"
            >
              <Money :size="20" />
            </button>
          </div>
        </span>
      </template>
    </TableApp>

    <SendToWppModal
      :data="dataToWhatsapp"
      :openModal="wppOpenModal"
      @handleOpenModal="(openModal) => (wppOpenModal = openModal)"
      module="os"
    />

    <b-modal
      id="modalAnexosOS"
      title="Anexos da OS:"
      centered
      size="sm"
      hide-footer
    >
      <div v-if="modalAnexosData">
        <ul class="list-unstyled">
          <li v-for="(anexo, idx) in anexosArray(modalAnexosData)" :key="idx">
            <a :href="anexo.url" target="_blank">Anexo {{ anexo.num }}</a>
          </li>
          <li v-if="anexosArray(modalAnexosData).length === 0">
            Nenhum anexo encontrado.
          </li>
        </ul>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TableApp from "@/components/Table/Table2";
import swal from "sweetalert";
import { SistemaMixin } from "@/modules/Application";
import flatPickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
import Close from "vue-material-design-icons/FileCancel.vue";
import Whatsapp from "vue-material-design-icons/Whatsapp.vue";
import PdfIcon from "vue-material-design-icons/FilePdfBox.vue";
import PencilIcon from "vue-material-design-icons/Pencil.vue";
import Money from "vue-material-design-icons/CashCheck.vue";
import "flatpickr/dist/themes/material_blue.css";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import FilterFields from "@/components/FilterFields";
import SendToWppModal from "@/components/SendToWppModal";
import Menu from "vue-material-design-icons/Menu";
import { actionsStore } from "@/components/Table/actionsStore";
import Link from "vue-material-design-icons/LinkPlus.vue";
import VueSelect from "vue-select";
import { store } from "../storeOS";
import PaperclipIcon from "vue-material-design-icons/Paperclip.vue";
import ToggleSwitchOutline from "vue-material-design-icons/ToggleSwitchOutline.vue";
import ColumnVisibilitySidebar from "@/components/ColumnVisibility/ColumnVisibilitySidebar.vue";
import {
  createColumnVisibilityMixin,
  LIST_CONFIG_MODULES,
} from "@/components/ColumnVisibility/columnVisibilityMixin";

export default {
  name: "os",
  mixins: [
    SistemaMixin,
    createColumnVisibilityMixin({
      moduleConfig: LIST_CONFIG_MODULES.ORDEM_SERVICO,
      sidebarId: "sidebar-os-fields",
    }),
  ],
  components: {
    TableApp,
    ColumnVisibilitySidebar,
    Close,
    VueSelect,
    PdfIcon,
    PencilIcon,
    Whatsapp,
    FilterFields,
    Link,
    SendToWppModal,
    Menu,
    Money,
    PaperclipIcon,
    ToggleSwitchOutline,
  },
  data() {
    return {
      store,
      actionsStore,
      components: {
        flatPickr,
      },
      wppNumberToSend: null,
      wppOpenModal: false,
      isLoading: false,
      userEmailsToSend: [],
      selectedEmail: null,
      nfeIdToSendEmail: null,
      ccEmail: null,
      dataToWhatsapp: null,
      osStatus: [],
      statusSelected: null,
      statusResumoSelecionado: null,
      ordensServicoResumoTotais: {
        total: 0,
        faturadas: 0,
        porStatus: 0,
      },
      fields: [
        {
          label: "OS",
          field: "numero",
          type: "text",
          slot: true,
          sortable: false,
          width: "3%",
        },
        {
          label: "Cliente",
          field: "cliente",
          type: "text",
          slot: true,
          sortable: true,
          width: "15%",
        },
        {
          label: "Objeto",
          field: "objeto",
          type: "text",
          slot: true,
          width: "10%",
          sortable: false,
        },
        {
          label: "Local de Atendimento",
          field: "local_atendimento",
          type: "text",
          slot: true,
          width: "12%",
          sortable: false,
          defaultVisible: false,
        },
        {
          label: "Identificadores",
          field: "identificadores",
          type: "text",
          slot: true,
          width: "25%",
          sortable: false,
        },
        {
          label: "Técnico",
          field: "tecnico",
          type: "text",
          slot: true,
          sortable: false,
          width: "10%",
        },
        {
          label: "Entrada",
          field: "dataEntrada",
          sortable: false,
          slot: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd-MM-yyyy",
        },
        {
          label: "Previsão",
          field: "dataPrevisao",
          sortable: false,
          slot: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd-MM-yyyy",
        },
        {
          label: "Saída",
          field: "dataSaida",
          sortable: false,
          slot: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd-MM-yyyy",
        },
        {
          label: "Status",
          width: "20%",
          field: "status",
          sortable: true,
          slot: true,
        },
        {
          label: "Total",
          field: "valorTotal",
          sortable: false,
          slot: true,
          width: "10%",
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "30%",
        },
      ],
      numeroNota: null,
      nomeCliente: null,
      correcaoText: null,
      pdfCorrecaoUrl: null,
      xmlCorrecaoUrl: null,
      nfeId: null,
      form: {},
      serie: null,
      xmlFiles: [],
      repetirEtiqueta: 1,
      etiquetaCompleta: false,
      gerar_financeiro: true,
      movimentar_estoque: true,
      permitido_faturar: false,
      data_faturamento: null,
      anexoCopia: null,
      urlCopiaAnexo: null,
      modalAnexosData: null,
      clienteTelefonesOs: {},
    };
  },
  methods: {
    async getDataInit() {
      const { data } = await this.$http.post("/ordemservico/status");
      this.osStatus = data;
      await this.getOrdensServicoResumo();
    },
    async contarOrdensServico(columnFilters = {}) {
      const { data } = await this.$http.post("/ordemservico/lista", {
        columnFilters,
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 1,
      });

      return Number(data?.total || 0);
    },
    async getOrdensServicoResumo() {
      const [total, faturadas] = await Promise.all([
        this.contarOrdensServico(),
        this.contarOrdensServico({ status: "Faturada" }),
      ]);

      this.ordensServicoResumoTotais = {
        ...this.ordensServicoResumoTotais,
        total,
        faturadas,
      };

      await this.getTotalOrdensServicoPorStatus();
    },
    async getTotalOrdensServicoPorStatus() {
      if (!this.statusResumoSelecionado) {
        this.ordensServicoResumoTotais = {
          ...this.ordensServicoResumoTotais,
          porStatus: 0,
        };
        return;
      }

      const porStatus = await this.contarOrdensServico({
        status: this.statusResumoSelecionado.descricao,
      });

      this.ordensServicoResumoTotais = {
        ...this.ordensServicoResumoTotais,
        porStatus,
      };
    },
    temAnexo(os) {
      for (let i = 1; i <= 6; i++) {
        if (os[`anexo_${i}`]) return true;
      }
      return false;
    },
    abrirModalAnexos(os) {
      this.modalAnexosData = os;
      this.$bvModal.show("modalAnexosOS");
    },
    anexosArray(os) {
      const anexos = [];
      for (let i = 1; i <= 6; i++) {
        const url = os[`anexo_${i}`];
        if (url) {
          anexos.push({ num: i, url });
        }
      }
      return anexos;
    },
    clienteTelefone(os) {
      const telefoneLinha = this.extrairTelefoneCliente(os);
      if (telefoneLinha) return telefoneLinha;

      const cacheKey = this.clienteTelefoneCacheKey(os);
      if (!cacheKey) return null;
      if (this.clienteTelefonesOs[cacheKey] !== undefined) {
        return this.clienteTelefonesOs[cacheKey];
      }

      this.$set(this.clienteTelefonesOs, cacheKey, null);
      this.buscarTelefoneClienteOs(os, cacheKey);

      return null;
    },
    extrairTelefoneCliente(os) {
      const fones =
        os?.fones ??
        os?.cliente?.fones ??
        os?.telefones ??
        os?.cliente?.telefones ??
        [];
      const telefones = [
        os?.telefone,
        os?.fone,
        os?.whatsapp,
        os?.celular,
        os?.cliente_telefone,
        os?.cliente_fone,
        os?.cliente_whatsapp,
        os?.cliente_celular,
        os?.cliente?.telefone,
        os?.cliente?.fone,
        os?.cliente?.whatsapp,
        os?.cliente?.celular,
        ...(Array.isArray(fones) ? fones : [fones]),
      ];

      const telefone = telefones
        .map((item) => this.normalizarTelefoneCliente(item))
        .filter(Boolean)
        .join(", ");

      return telefone || null;
    },
    clienteTelefoneCacheKey(os) {
      return os?.id_pessoa ?? os?.cliente?.id_pessoa ?? null;
    },
    async buscarTelefoneClienteOs(os, cacheKey) {
      const id_pessoa = os?.id_pessoa ?? os?.cliente?.id_pessoa;
      if (!id_pessoa) return;

      try {
        const { data } = await this.$http.post("/pessoa/get-fone-whatsapp", {
          id_pessoa,
        });

        this.$set(
          this.clienteTelefonesOs,
          cacheKey,
          this.normalizarTelefoneCliente(data?.whatsapp)
        );
      } catch {
        this.$set(this.clienteTelefonesOs, cacheKey, null);
      }
    },
    normalizarTelefoneCliente(telefone) {
      if (!telefone) return null;

      const valor =
        typeof telefone === "object"
          ? telefone.fone ??
            telefone.telefone ??
            telefone.whatsapp ??
            telefone.celular
          : telefone;

      if (!valor) return null;

      const raw = String(valor).trim();
      if (!raw || raw === "null") return null;

      const digits = raw.replace(/\D/g, "");
      if (digits.length === 11) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
      }
      if (digits.length === 10) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
      }

      return raw;
    },
    localAtendimentoLabel(os) {
      return os?.local_atendimento || "";
    },
    async estornarOS() {
      const { id_ordem_servico } = this.actionsStore?.selectedRows[0];

      this.addLoadingToButton("estornar_os");

      try {
        const response = await this.$http.post(
          "/ordemservico/estornar-faturamento",
          {
            id_ordem_servico,
          }
        );

        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("OS estornada com sucesso!");
        this.$bvModal.hide("estornarOSModal");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("estornar_os");
    },
    async faturarOrdemServico() {
      if (!this.data_faturamento) {
        this.$toast.wa("Informe a data do faturamento!");
        return;
      }
      const { id_ordem_servico } = this.actionsStore?.selectedRows[0];

      this.addLoadingToButton("faturarOrdemServico");

      try {
        const response = await this.$http.post("/ordemservico/faturar", {
          id_ordem_servico,
          movimentar_estoque: this.movimentar_estoque,
          gerar_financeiro: this.gerar_financeiro,
          data_faturamento: this.data_faturamento,
        });

        if (response["data"]["url_os_faturada"]) {
          window.open(response["data"]["url_os_faturada"], "_blank");
        }

        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("OS faturada com sucesso!");
        this.$bvModal.hide("faturarOS");
        this.data_faturamento = null;
        this.movimentar_estoque = true;
        this.permitido_faturar = null;
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("faturarOrdemServico");
    },
    async imprimirEtiqueta() {
      const { id_ordem_servico } = this.actionsStore?.selectedRows[0];

      this.addLoadingToButton("imprimirEtiqueta");

      try {
        const response = await this.$http.post(
          "/ordemservico/impressao-etiqueta",
          {
            id_ordem_servico,
            repetir: this.repetirEtiqueta,
            completa: this.etiquetaCompleta,
          }
        );
        if (response["data"]["url_etiqueta"]) {
          window.open(response["data"]["url_etiqueta"], "_blank");
        }
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Etiqueta impressa com sucesso!");
        this.$bvModal.hide("modalEtiqueta");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("imprimirEtiqueta");
    },
    async anexarCopia() {
      const { id_ordem_servico } = this.actionsStore?.selectedRows[0];

      this.addLoadingToButton("copiaAnexo");

      if (!this.urlCopiaAnexo) {
        this.$toast.warning("Selecione a cópia do arquivo!");
        return;
      }

      let os = new FormData();

      os.append("id_ordem_servico", id_ordem_servico);
      os.append("copia_arquivo", this.anexoCopia);

      try {
        const response = await this.$http.post(
          "/ordemservico/upload-copia-arquivo",
          os
        );
        if (response["data"]["copia_arquivo"]) {
          window.open(response["data"]["copia_arquivo"], "_blank");
        }
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Anexo da OS importado com sucesso!");
        this.$bvModal.hide("copiaArquivo");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("copiaAnexo");
    },
    async imprimirComprovante() {
      const { id_ordem_servico } = this.actionsStore?.selectedRows[0];

      this.addLoadingToButton("comprovanteEntrega");

      try {
        const response = await this.$http.post(
          "/ordemservico/impressao-comprovante",
          {
            id_ordem_servico,
          }
        );
        if (response["data"]["url_comprovante_entrega"]) {
          window.open(response["data"]["url_comprovante_entrega"], "_blank");
        }
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Comprovante de entrega impresso com sucesso!");
        this.$bvModal.hide("comprovanteEntrega");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("comprovanteEntrega");
    },
    async updateDataSaida() {
      if (!this.dataSaida) {
        this.$toast.warning("Informe a data de saída!");
        return;
      }

      const { id_ordem_servico } = this.actionsStore?.selectedRows[0];

      this.addLoadingToButton("dataSaidaButton");

      try {
        const response = await this.$http.post(
          "/ordemservico/update-data-saida",
          {
            id_ordem_servico,
            data_saida: this.dataSaida,
          }
        );
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Data de saída atualizada com sucesso!");
        this.$bvModal.hide("dataBaixa");
        this.dataSaida = null;
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("dataSaidaButton");
    },
    async duplicar() {
      const { id_ordem_servico } = this.actionsStore?.selectedRows[0];

      this.addLoadingToButton("doubleOS");

      try {
        await this.$http.post("/ordemservico/duplicar", {
          id_ordem_servico,
        });
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("OS duplicada com sucesso!");
        this.$refs.osList.refresh();
        this.$bvModal.hide("duplicarOS");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("doubleOS");
    },
    async atualizarStatus() {
      const idsOS = this.actionsStore?.selectedRows.map((os) => ({
        id_ordem_servico: os.id_ordem_servico,
      }));
      if (!this.statusSelected) {
        this.$toast.error("Selecione o status");
        return;
      }
      this.addLoadingToButton("updateOS");
      try {
        await this.$http.post("/ordemservico/update-status", {
          ordem_servicos: idsOS,
          status: this.statusSelected.id,
        });
        this.$bvModal.hide("atualizarOS");
        this.$toast.success("OS(s) atualizada(s) com sucesso!");
        this.statusSelected = null;
        this.removeLoadingToButton("updateOS");
        this.$refs.osList.refresh();
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
      } catch (error) {
        this.removeLoadingToButton("updateOS");
        console.log(error);
      }
    },
    linkOSFaturada(data) {
      swal({
        title: "Deseja visualizar a OS faturada?",
        text: "Ao confirmar será aberto em nova aba o PDF",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        swal.close();
        swal.stopLoading();
        this.$copyText(data.link);
        if (data.link_faturamento) {
          window.open(data.link_faturamento, "_blank");
        }
        this.$toast.success("PDF gerado com sucesso!");
      });
    },
    doCopy(data) {
      swal({
        title: "Deseja enviar o link para o cliente?",
        text: "Ao confirmar será copiado para a area de transferencia o link",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        swal.close();
        swal.stopLoading();
        this.$copyText(data.link);
        this.$toast.success("Link copiado com sucesso!");
        this.$http.post("/ordemservico/update-status-os", {
          id_ordem_servico: data.id_ordem_servico,
        });
        this.$refs.osList.refresh();
      });
    },
    async shareToWhatsapp(data) {
      this.dataToWhatsapp = data;
      this.wppOpenModal = true;
    },
    imprimirOS(data) {
      swal({
        title: "Deseja gerar o pdf da OS?",
        text: "Aguarde, pois será gerado o pdf automaticamente!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/ordemservico/impressao", {
            id_ordem_servico: data.id_ordem_servico,
          })
          .then((result) => {
            if (result.data) {
              window.open(result.data.url_os, "_blank");
            }
            swal.stopLoading();
            swal.close();
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    imprimirOSTecnico(data) {
      swal({
        title: "Deseja gerar a impressão da OS para o técnico?",
        text: "Aguarde, pois será gerado o pdf automaticamente!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/ordemservico/impressao-tecnico", {
            id_ordem_servico: data.id_ordem_servico,
          })
          .then((result) => {
            if (result.data) {
              window.open(result.data.url_os, "_blank");
            }
            swal.stopLoading();
            swal.close();
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    deleteOS(data) {
      this.getRequestAdmin(() => {
        swal({
          title: "Deseja deletar a OS?",
          icon: "info",
          buttons: {
            cancel: {
              text: "Cancelar",
              value: "cancel",
              visible: true,
              closeModal: true,
            },
            confirm: {
              text: "OK",
              visible: true,
              closeModal: false,
            },
          },
          dangerMode: false,
          closeModal: false,
          closeOnClickOutside: false,
        }).then(async (value) => {
          if (value === "cancel") {
            swal.close();
            swal.stopLoading();
            return;
          }

          await this.$http
            .post("/ordemservico/delete", {
              id_ordem_servico: data.id_ordem_servico,
            })
            .then(() => {
              swal.stopLoading();
              swal.close();
              this.$toast.success("OS cancelada com sucesso!");
              this.$refs.osList.refresh();
              this.actionsStore.updateTable = !this.actionsStore.updateTable;
            })
            .catch(() => {
              swal.stopLoading();
              swal.close();
            });
        });
      });
    },
    async editarOS({ id_ordem_servico }) {
      swal({
        title: "Deseja editar a OS?",
        text: "Você ira ser direcionado para a pagina de edição aguarde...",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }

        await this.$http
          .post("/ordemservico/find", {
            id_ordem_servico,
          })
          .then(({ data }) => {
            swal.stopLoading();
            swal.close();
            this.$toast.info("Você será redirecionado agora");
            this.$router.push({
              name: "ordensServicosNova",
              params: { osData: { ...data, id_ordem_servico } },
            });
          })
          .catch(() => {
            swal.stopLoading();
            this.$toast.error("Erro ao solicitar o endpoint da NFe");
            swal.close();
          });
      });
    },
    formataIdentificadores(identificadores) {
      if (!identificadores) return;
      if (identificadores === "null") return;

      const identificador = JSON.parse(identificadores);
      var identificadorFormatado = "";
      identificador.forEach((identifi) => {
        var valorIdentificador = "";
        if (identifi.value) {
          valorIdentificador = identifi.value;
        }
        identificadorFormatado +=
          identifi.descricao + ": " + valorIdentificador + ", ";
      });
      return identificadorFormatado;
    },
    formataPagamento(pagamento) {
      const pagamentos = JSON.parse(pagamento);
      var pagamentoFormatado = "";
      pagamentos.forEach((pag) => {
        if (pag.valor == 0) {
          pagamentoFormatado =
            "Ordem de Serviço sem valores para realizar faturamento.";
          this.permitido_faturar = true;
        }

        if (pag.valor != 0) {
          this.permitido_faturar = false;
          pagamentoFormatado +=
            pag.forma_pagamento.descricao +
            ": R$ " +
            this.numberToReal(pag.valor, 2);
        }
      });
      return pagamentoFormatado;
    },
    setAnexoCopia(event) {
      this.anexoCopia = event.target.files[0];
      this.urlCopiaAnexo = URL.createObjectURL(this.anexoCopia);
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
    totalOrdensServico() {
      return this.ordensServicoResumoTotais.total;
    },
    totalOrdensServicoFaturadas() {
      return this.ordensServicoResumoTotais.faturadas;
    },
    totalOrdensServicoNaoFaturadas() {
      return Math.max(
        this.ordensServicoResumoTotais.total -
          this.ordensServicoResumoTotais.faturadas,
        0
      );
    },
    totalOrdensServicoPorStatus() {
      return this.ordensServicoResumoTotais.porStatus;
    },
  },
  created() {
    this.getDataInit();
  },
  async mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    let inputs = ['input[placeholder="Data"]'];
    inputs.forEach(function (input) {
      flatPickr(input, {
        dateFormat: "Y-m-d",
        allowInput: true,
        locale: Portuguese,
      });
    });
  },
  watch: {
    "actionsStore.updateTable"() {
      this.getOrdensServicoResumo();
    },
    statusResumoSelecionado() {
      this.getTotalOrdensServicoPorStatus();
    },
  },
};
</script>

<style>
.os-status-summary {
  background: #fff;
  border-radius: 0.42rem 0.42rem 0 0;
  box-shadow: 0 0 30px 0 rgb(82 63 105 / 5%);
  margin-bottom: -1px;
  overflow: visible;
  padding: 0.75rem 1.25rem 0;
  position: relative;
  z-index: 4;
}

.os-status-summary-table {
  border-collapse: separate;
  border-spacing: 0;
  overflow: visible;
  table-layout: fixed;
  width: 100%;
}

.os-status-summary-table th,
.os-status-summary-table td {
  border-right: 1px solid #ebedf3;
  text-align: center;
  vertical-align: middle;
}

.os-status-summary-table th:last-child,
.os-status-summary-table td:last-child {
  border-right: 0;
}

.os-status-summary-table th {
  background: #f3f6f9;
  color: #7e8299;
  font-size: 0.82rem;
  font-weight: 700;
  height: 44px;
  letter-spacing: 0.02em;
  padding: 0.5rem 1rem;
  text-transform: uppercase;
}

.os-status-summary-table td {
  color: #3f4254;
  font-size: 1rem;
  font-weight: 700;
  height: 44px;
  padding: 0.5rem 1rem;
}

.os-status-summary-value {
  align-items: center;
  color: #181c32;
  display: inline-flex;
  font-size: 1.15rem;
  font-weight: 700;
  justify-content: center;
  min-height: 28px;
  min-width: 52px;
}

.os-status-summary-select {
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 auto;
  max-width: 240px;
  min-width: 210px;
  text-align: left;
  text-transform: none;
}

.os-status-summary-select.form-control {
  background: #fff;
  border: 1px solid #e4e6ef;
  color: #3f4254;
  height: 36px;
  padding-bottom: 0.35rem;
  padding-top: 0.35rem;
}

.flatpickr-months .flatpickr-month,
.flatpickr-current-month .flatpickr-monthDropdown-months,
.flatpickr-weekdays,
span.flatpickr-weekday {
  background: var(--primary-color) !important;
}

.headerColumn {
  text-align: start;
}

.flatpickr-calendar.arrowTop:before {
  border-bottom-color: var(--primary-color) !important;
  color: var(--primary-color) !important;
}

.os-local-atendimento {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
